import { Box, Typography } from '@mui/material';

const StatCard = ({ title, value, icon, color, subtitle }) => {
  return (
    <Box
      sx={{
        bgcolor: '#f2f2f3',
        borderRadius: 0,
        p: 3,
        height: '100%',
        boxShadow: '0 1px 2px rgba(43,43,45,.14)',
        border: '1px solid rgba(29,31,32,0.16)',
        borderTop: '3px solid #5980a6',
        cursor: 'default',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2.5 }}>
        <Typography
          sx={{
            fontSize: '0.625rem',
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'rgba(29,31,32,0.55)',
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 0,
            border: '1px solid rgba(29,31,32,0.16)',
            bgcolor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#416180',
            flexShrink: 0,
            '& svg': { fontSize: 20 },
          }}
        >
          {icon}
        </Box>
      </Box>

      <Typography
        sx={{
          fontFamily: '"Barlow Condensed", system-ui, sans-serif',
          fontSize: '2.5rem',
          fontWeight: 600,
          color: '#1d1f20',
          lineHeight: 1,
          mb: 0.75,
          letterSpacing: '-0.015em',
        }}
      >
        {value ?? '\u2014'}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            fontSize: '0.8rem',
            color: 'rgba(29,31,32,0.55)',
            mt: 0.75,
            fontWeight: 500,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default StatCard;
